<template>
  <div>领券记录</div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

</style>